import React from "react";
import ReactDOM from "react-dom/client";
import { MarketingApp } from "./MarketingApp";
import { marketingGa4Reporter } from "./analytics/ga4Reporter";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <MarketingApp report={marketingGa4Reporter} />
  </React.StrictMode>,
);
